var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingicon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5993 16.5585C13.7845 16.5585 11.9878 16.1665 10.2093 15.3825C8.43079 14.5985 6.81561 13.4806 5.36376 12.0287C3.91191 10.5769 2.79398 8.96533 2.00998 7.19407C1.22598 5.42282 0.833984 3.62253 0.833984 1.7932V0.87854H5.97354L6.77931 5.25586L4.29665 7.76029C4.61606 8.32651 4.97176 8.8637 5.36376 9.37184C5.75576 9.87999 6.1768 10.3518 6.62687 10.7874C7.04791 11.2084 7.50887 11.6113 8.00976 11.9961C8.51064 12.3808 9.05146 12.7401 9.6322 13.0741L12.1584 10.5478L16.514 11.4407V16.5585H15.5993ZM3.46909 6.10519L4.90643 4.66786L4.5362 2.62076H2.59798C2.67058 3.27409 2.77946 3.88749 2.92465 4.46097C3.06983 5.03445 3.25132 5.58252 3.46909 6.10519ZM11.2655 13.9016C11.8463 14.1484 12.4306 14.3444 13.0186 14.4896C13.6066 14.6348 14.191 14.7292 14.7718 14.7727V12.8563L12.7246 12.4425L11.2655 13.9016Z",
    fill: "#84818A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingicon1);
export default __webpack_public_path__ + "static/media/Settingicon1.22afe3fdeb7b3736571321106dc6d84f.svg";
export { ForwardRef as ReactComponent };